class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }  
  static renderPage(searchParams, event, updateURLHash = true) {
    // ************ Banner Injection ************ //
    const productGrid = document.querySelector("#product-grid");
    if (!productGrid) return;  
    productGrid.querySelectorAll(".custom-collection-banner").forEach(el => el.remove());
    const banner1El = document.querySelector(".collection-bnr1");
    const banner2El = document.querySelector(".collection-bnr2");
    const banner3El = document.querySelector(".collection-bnr3");
    const items = productGrid.querySelectorAll(".grid__item");
    if (banner1El && items[5]) {
      const banner1 = document.createElement("li");
      banner1.className = "grid__item custom-collection-banner";
      banner1.innerHTML = banner1El.innerHTML;
      items[5].after(banner1);
    }
    if (banner2El && items[9]) {
      const banner2 = document.createElement("li");
      banner2.className = "grid__item custom-collection-banner";
      banner2.innerHTML = banner2El.innerHTML;
      items[9].after(banner2);
    }
    if (banner3El && items[17]) {
      const banner3 = document.createElement("li");
      banner3.className = "grid__item custom-collection-banner";
      banner3.innerHTML = banner3El.innerHTML;
      items[17].after(banner3);
    }

    // ************ product card variant ************ //
    document.querySelectorAll('.shape-data .slider').forEach(slider => {
      slider.addEventListener('click', e => {
        const cardOption = e.target.closest('.variant-card-option');
        if (!cardOption) return;
        const input = cardOption.querySelector('input[type="radio"]');
        if (!input) return;
        const { imageSrc, secondImageSrc, productId, variantId } = input.dataset;
        if (!imageSrc || !productId || !variantId) return;
        // Mark active
        cardOption.parentElement.querySelectorAll('.variant-card-option').forEach(el => el.classList.remove('active'));
        cardOption.classList.add('active');
        const card = document.querySelector(`.card__media[data-product-id='${productId}']`);
        if (!card) return;
        const updateImage = (selector, src) => {
          const img = card.querySelector(selector);
          if (img && src) {
            img.src = src;
            img.srcset = `
              ${src.replace('.jpg', '_327x327.jpg')} 1x,
              ${src.replace('.jpg', '_1100x1100.jpg')} 2x,
              ${src.replace('.jpg', '_2048x2048.jpg')} 3x
            `.trim();
          }
        };
        updateImage('.desktop-view img.card-main-image', imageSrc);
        updateImage('.desktop-view img.card-second-image', secondImageSrc);
        updateImage('.mobile-slider img.card-main-image', imageSrc);
        updateImage('.mobile-slider img:not(.card-main-image)', secondImageSrc);
        const mediaLink = card.querySelector('a.media--hover-effect');
        if (mediaLink) {
          const url = new URL(mediaLink.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          mediaLink.href = url.toString();
        }
        const cardWrapper = card.closest('.card-wrapper');
        if (cardWrapper) {
          const contentLink = cardWrapper.querySelector('.card__content');
          if (contentLink) {
            const url = new URL(contentLink.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            contentLink.href = url.toString();
          }
        }
      });
    });

    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });

    // ************ select option show in sorting filter ************ //
    const allowedOptions = [
      'Featured',
      'Best selling',
      'Price, low to high',
      'Price, high to low'
    ];
    const sortIds = ['#SortBy', '#SortBy-mobile'];  
    sortIds.forEach(id => {
      const sortBySelect = document.querySelector(id);    
      if (sortBySelect) {
        Array.from(sortBySelect.options).forEach(option => {
          if (!allowedOptions.includes(option.text.trim())) {
            option.remove();
          }
        });
      }
    });

    // ************ desktop active label  ************ //
    const desktopfilterSections = document.querySelectorAll('.desktop-facets__details');
    desktopfilterSections.forEach(section => {
      const checkboxes = section.querySelectorAll('input[type="checkbox"]');
      const activeDesktopLabel = section.querySelector('.active-desktop-label');
      const activeDesktopSummaryLabel = section.querySelector('.active-desktopsummary-label');    
      const updateActiveDesktopLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;    
        const activeText = checkedLabel ? checkedLabel : 'All';    
        if (activeDesktopLabel) {
          activeDesktopLabel.textContent = activeText;
        }    
        if (activeDesktopSummaryLabel) {
          activeDesktopSummaryLabel.textContent = activeText;
        }
      };    
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveDesktopLabel);
      });    
      updateActiveDesktopLabel(); // Initial call on load
    });

    // ************ mobile active label  ************ //
    const filterSections = document.querySelectorAll('.mobile-facets-active-lbl');
    filterSections.forEach(section => {
      const index = section.dataset.index;
      const details = document.querySelector(`.mobile-facets__details[data-index="mobile-${index}"]`);
      const checkboxes = details.querySelectorAll('input[type="checkbox"]');
      const activeMobileLabel = section.querySelector('.active-mobile-label');
      const activeSummaryLabel = details.querySelector('.active-summary-label');    
      const updateActiveLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;
        const activeText = checkedLabel ? checkedLabel : 'All';    
        activeMobileLabel.textContent = activeText;
        activeSummaryLabel.textContent = activeText;
      };    
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveLabel);
      });  
      updateActiveLabel(); // On page load call
    });

    // ************ select option show in style filter ************ //
    function filterFacetItems(allowedFilters) {
      const facetItems = document.querySelectorAll('.facets__item');
      facetItems.forEach(item => {
        const textLabel = item.querySelector('.custom-facet-checkbox');
        if (textLabel && !allowedFilters.includes(textLabel.textContent.trim())) {
          item.remove();
        }
      });
    }      
    function hideStyleFilter() {
      const desktopStyleFilter = document.querySelector('details.style-filter'); 
      const mobileStyleFilter = document.querySelector('.style-filter.mobile-facets__details'); 
      const mobileStyleContainer = document.querySelector('.mobile-style'); 
      if (desktopStyleFilter) {
        desktopStyleFilter.style.display = 'none';
      }    
      if (mobileStyleFilter) {
        mobileStyleFilter.style.display = 'none';
      }      
      if (mobileStyleContainer) {
        mobileStyleContainer.style.display = 'none';
      }
    }    
    const summaryElement = document.querySelector('.custom-facets__summary');
    if (summaryElement) {
      const filterLabelElement = summaryElement.querySelector('.filter-label');
      if (filterLabelElement) {
        const filterLabel = filterLabelElement.textContent.trim();
        const currentPath = window.location.pathname;      
        // Collections where we want to hide the "Style" filter
        const hideStyleCollections = [
          'eternity-rings', 'mens-rings', 'stackable-rings', 'fashion-rings',
          'tennis-necklaces', 'fashion-necklaces',
          'stud-earrings', 'hoop-earrings', 'fashion-earrings',
          'tennis-bracelets', 'bangle-bracelets', 'fashion-bracelets', 'fashion-pendant', 'toi-et-moi', 'exclusive-pick' 
        ];      
        // Check if current path contains any of the above collections
        if (hideStyleCollections.some(slug => currentPath.includes(`/collections/${slug}`))) {
          hideStyleFilter();
        }      
        // Existing logic for filter items
        if (currentPath.startsWith('/collections/rings')) {
          const allowedFilters = [
            "Engagement", "Wedding", "Eternity", "Men's Rings", "Stackable", "Fashion", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/engagement-rings')) {
          const allowedFilters = [
            "Halo", "Side Stone", "Solitaire", "Hidden Halo", "Three Stone", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/wedding-rings')) {
          const allowedFilters = [
            "Ring Enhancer", "Wedding & Anniversary"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/necklaces')) {
          const allowedFilters = [
            "Fashion", "Pendant", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/earrings')) {
          const allowedFilters = [
            "Fashion", "Hoop", "Stud"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/bracelets')) {
          const allowedFilters = [
            "Bangle", "Fashion", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/anniversary-gifts')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/gifts-under-1000')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        }
      }
    }

    // ************ wishlist ************ //
(function (Wishlist, $) {

  let $wishlistItemCount = $('.wishlist-item-count');
  let wishlist = getWishlistFromStorage();

  /* ------------------------------------
     ✔ SAFE LOCAL STORAGE READ
  ------------------------------------ */
  function getWishlistFromStorage() {
    try {
      return JSON.parse(localStorage.getItem('user_wishlist')) || [];
    } catch (e) {
      console.error('Error reading wishlist from storage', e);
      return [];
    }
  }

  function saveWishlistToStorage() {
    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
  }

  /* ------------------------------------
     ✔ ADD / REMOVE ITEM
  ------------------------------------ */
  function toggleWishlistItem(productHandle) {
    const index = wishlist.indexOf(productHandle);
    if (index > -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(productHandle);
    }
    saveWishlistToStorage();
  }

  /* ------------------------------------
     ✔ UPDATE WISHLIST BUTTON STATUS
  ------------------------------------ */
  function activateItemsInWishlist() {
    $('.wishlist-btn').each(function () {
      const productHandle = $(this).attr('data-product-handle');
      if (wishlist.includes(productHandle)) {
        $(this).addClass('included');
      } else {
        $(this).removeClass('included');
      }
    });
  }

  /* ------------------------------------
     ✔ SHOW ONLY WISHLIST ITEMS
  ------------------------------------ */
  function displayOnlyWishlistItems() {
    let tiles = $('.wishlist-tile-container');

    tiles.each(function () {
      const handle = $(this).attr('data-product-handle');
      if (!wishlist.includes(handle)) {
        $(this).remove();
      }
    });

    if ($('.wishlist-tile-container').length === 0) {
      $('.wishlist-grid--empty-list').addClass('is_visible');
    } else {
      $('.wishlist-grid--empty-list').removeClass('is_visible');
    }
  }

  /* ------------------------------------
     ✔ UPDATE COUNT
  ------------------------------------ */
  function updateWishlistItemCount() {
    $wishlistItemCount.text(wishlist.length);
  }

  /* ------------------------------------
     ✔ BIND BUTTON EVENTS
  ------------------------------------ */
  function bindWishlistActions() {

    // Add / Remove from product card
    $('.wishlist-btn').off('click').on('click', function (e) {
      e.preventDefault();

      const productHandle = $(this).attr('data-product-handle');

      toggleWishlistItem(productHandle);
      $(this).toggleClass('included');

      updateWishlistItemCount();
    });

    // Remove from wishlist page
    $('.remove-wishlist').off('click').on('click', function (e) {
      e.preventDefault();

      const productHandle = $(this).attr('data-product-handle');
      wishlist = wishlist.filter(item => item !== productHandle);

      saveWishlistToStorage();

      $(this).closest('.wishlist-tile-container').remove();

      updateWishlistItemCount();
      activateItemsInWishlist(); // Sync buttons everywhere
      displayOnlyWishlistItems();
    });
  }

  /* ------------------------------------
     ✔ PUBLIC FUNCTIONS
  ------------------------------------ */
  Wishlist.reInit = function () {
    wishlist = getWishlistFromStorage();
    activateItemsInWishlist();
    updateWishlistItemCount();
    bindWishlistActions();
  }

  Wishlist.init = function () {
    wishlist = getWishlistFromStorage();

    if (window.location.href.includes('pages/wishlist')) {
      displayOnlyWishlistItems();
    }

    Wishlist.reInit();
  }

  $(document).ready(function () {
    Wishlist.init();
  });

})(window.Wishlist = window.Wishlist || {}, jQuery);

    // ************ at a time only one option select in style filter ************ //
    ['.style-filter', '.shape-filter'].forEach(selector => {
      document.querySelectorAll(selector).forEach(filterWrapper => {
        const checkboxes = filterWrapper.querySelectorAll('input[type="checkbox"]');      
        checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', function () {
            if (this.checked) {
              checkboxes.forEach(item => {
                if (item !== this) {
                  item.checked = false;
                }
              });
            }
          });
        });
      });
    });
    // ************ end at a time only one option select in style filter ************ //

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    sections.forEach((section) => { 
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    // ************ Banner Injection ************ //
    const productGrid = document.querySelector("#product-grid");
    if (!productGrid) return;
    productGrid.querySelectorAll(".custom-collection-banner").forEach(el => el.remove());  
    const banner1El = document.querySelector(".collection-bnr1");
    const banner2El = document.querySelector(".collection-bnr2");
    const banner3El = document.querySelector(".collection-bnr3");  
    const items = productGrid.querySelectorAll(".grid__item");  
    if (banner1El && items[5]) {
      const banner1 = document.createElement("li");
      banner1.className = "grid__item custom-collection-banner";
      banner1.innerHTML = banner1El.innerHTML;
      items[5].after(banner1);
    }
    if (banner2El && items[9]) {
      const banner2 = document.createElement("li");
      banner2.className = "grid__item custom-collection-banner";
      banner2.innerHTML = banner2El.innerHTML;
      items[9].after(banner2);
    }
    if (banner3El && items[17]) {
      const banner3 = document.createElement("li");
      banner3.className = "grid__item custom-collection-banner";
      banner3.innerHTML = banner3El.innerHTML;
      items[17].after(banner3);
    }

    // ************ product card variant ************ // 
    document.querySelectorAll('.shape-data .slider').forEach(slider => {
      slider.addEventListener('click', e => {
        const cardOption = e.target.closest('.variant-card-option');
        if (!cardOption) return;
        const input = cardOption.querySelector('input[type="radio"]');
        if (!input) return;
        const { imageSrc, secondImageSrc, productId, variantId } = input.dataset;
        if (!imageSrc || !productId || !variantId) return;
        cardOption.parentElement.querySelectorAll('.variant-card-option').forEach(el => el.classList.remove('active'));
        cardOption.classList.add('active');
        const card = document.querySelector(`.card__media[data-product-id='${productId}']`);
        if (!card) return;
        const updateImage = (selector, src) => {
          const img = card.querySelector(selector);
          if (img && src) {
            img.src = src;
            img.srcset = `
              ${src.replace('.jpg', '_327x327.jpg')} 1x,
              ${src.replace('.jpg', '_1100x1100.jpg')} 2x,
              ${src.replace('.jpg', '_2048x2048.jpg')} 3x
            `.trim();
          }
        };
        updateImage('.desktop-view img.card-main-image', imageSrc);
        updateImage('.desktop-view img.card-second-image', secondImageSrc);
        updateImage('.mobile-slider img.card-main-image', imageSrc);
        updateImage('.mobile-slider img:not(.card-main-image)', secondImageSrc);
        const mediaLink = card.querySelector('a.media--hover-effect');
        if (mediaLink) {
          const url = new URL(mediaLink.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          mediaLink.href = url.toString();
        }
        const cardWrapper = card.closest('.card-wrapper');
        if (cardWrapper) {
          const contentLink = cardWrapper.querySelector('.card__content');
          if (contentLink) {
            const url = new URL(contentLink.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            contentLink.href = url.toString();
          }
        }
      });
    });

    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });

    // ************ select option show in sorting filter ************ //
    const allowedOptions = [
      'Featured',
      'Best selling',
      'Price, low to high',
      'Price, high to low'
    ];
    const sortIds = ['#SortBy', '#SortBy-mobile'];  
    sortIds.forEach(id => {
      const sortBySelect = document.querySelector(id);
  
      if (sortBySelect) {
        Array.from(sortBySelect.options).forEach(option => {
          if (!allowedOptions.includes(option.text.trim())) {
            option.remove();
          }
        });
      }
    });

    // ************ desktop active label  ************ //
    const desktopfilterSections = document.querySelectorAll('.desktop-facets__details');
    desktopfilterSections.forEach(section => {
      const checkboxes = section.querySelectorAll('input[type="checkbox"]');
      const activeDesktopLabel = section.querySelector('.active-desktop-label');
      const activeDesktopSummaryLabel = section.querySelector('.active-desktopsummary-label');
  
      const updateActiveDesktopLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;
  
        const activeText = checkedLabel ? checkedLabel : 'All';
  
        if (activeDesktopLabel) {
          activeDesktopLabel.textContent = activeText;
        }
  
        if (activeDesktopSummaryLabel) {
          activeDesktopSummaryLabel.textContent = activeText;
        }
      };
  
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveDesktopLabel);
      });
  
      updateActiveDesktopLabel(); // Initial call on load
    });

    // ************ mobile active label  ************ //
    const filterSections = document.querySelectorAll('.mobile-facets-active-lbl');
    filterSections.forEach(section => {
      const index = section.dataset.index;
      const details = document.querySelector(`.mobile-facets__details[data-index="mobile-${index}"]`);
      const checkboxes = details.querySelectorAll('input[type="checkbox"]');
      const activeMobileLabel = section.querySelector('.active-mobile-label');
      const activeSummaryLabel = details.querySelector('.active-summary-label');    
      const updateActiveLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;    
        const activeText = checkedLabel ? checkedLabel : 'All';    
        activeMobileLabel.textContent = activeText;
        activeSummaryLabel.textContent = activeText;
      };    
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveLabel);
      });    
      updateActiveLabel(); // On page load call
    });

    // ************ select option show in style filter ************ //
    function filterFacetItems(allowedFilters) {
      const facetItems = document.querySelectorAll('.facets__item');
      facetItems.forEach(item => {
        const textLabel = item.querySelector('.custom-facet-checkbox');
        if (textLabel && !allowedFilters.includes(textLabel.textContent.trim())) {
          item.remove();
        }
      });
    }      
    function hideStyleFilter() {
      const desktopStyleFilter = document.querySelector('details.style-filter'); // desktop
      const mobileStyleFilter = document.querySelector('.style-filter.mobile-facets__details'); // mobile
      const mobileStyleContainer = document.querySelector('.mobile-style'); // additional mobile style container      
      if (desktopStyleFilter) {
        desktopStyleFilter.style.display = 'none';
      }      
      if (mobileStyleFilter) {
        mobileStyleFilter.style.display = 'none';
      }      
      if (mobileStyleContainer) {
        mobileStyleContainer.style.display = 'none';
      }
    }      
    const summaryElement = document.querySelector('.custom-facets__summary');
    if (summaryElement) {
      const filterLabelElement = summaryElement.querySelector('.filter-label');
      if (filterLabelElement) {
        const filterLabel = filterLabelElement.textContent.trim();
        const currentPath = window.location.pathname;      
        // Collections where we want to hide the "Style" filter
        const hideStyleCollections = [
          'eternity-rings', 'mens-rings', 'stackable-rings', 'fashion-rings',
          'tennis-necklaces', 'fashion-necklaces',
          'stud-earrings', 'hoop-earrings', 'fashion-earrings',
          'tennis-bracelets', 'bangle-bracelets', 'fashion-bracelets', 'fashion-pendant', 'toi-et-moi', 'exclusive-pick'
        ];      
        // Check if current path contains any of the above collections
        if (hideStyleCollections.some(slug => currentPath.includes(`/collections/${slug}`))) {
          hideStyleFilter();
        }      
        // Existing logic for filter items
        if (currentPath.startsWith('/collections/rings')) {
          const allowedFilters = [
            "Engagement", "Wedding", "Eternity", "Men's Rings", "Stackable", "Fashion", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/engagement-rings')) {
          const allowedFilters = [
            "Halo", "Side Stone", "Solitaire", "Hidden Halo", "Three Stone", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/wedding-rings')) {
          const allowedFilters = [
            "Ring Enhancer", "Wedding & Anniversary"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/necklaces')) {
          const allowedFilters = [
            "Fashion", "Pendant", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/earrings')) {
          const allowedFilters = [
            "Fashion", "Hoop", "Stud"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/bracelets')) {
          const allowedFilters = [
            "Bangle", "Fashion", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/anniversary-gifts')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/gifts-under-1000')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        }
      }
    }

    // ************ at a time only one option select in style filter ************ //
    ['.style-filter', '.shape-filter'].forEach(selector => {
      document.querySelectorAll(selector).forEach(filterWrapper => {
        const checkboxes = filterWrapper.querySelectorAll('input[type="checkbox"]');      
        checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', function () {
            if (this.checked) {
              checkboxes.forEach(item => {
                if (item !== this) {
                  item.checked = false;
                }
              });
            }
          });
        });
      });
    });
    // ************ end at a time only one option select in style filter ************ //

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    // ************ Banner Injection ************ //
    const productGrid = document.querySelector("#product-grid");
    if (!productGrid) return;  
    productGrid.querySelectorAll(".custom-collection-banner").forEach(el => el.remove());  
    const banner1El = document.querySelector(".collection-bnr1");
    const banner2El = document.querySelector(".collection-bnr2");
    const banner3El = document.querySelector(".collection-bnr3");  
    const items = productGrid.querySelectorAll(".grid__item");  
    if (banner1El && items[5]) {
      const banner1 = document.createElement("li");
      banner1.className = "grid__item custom-collection-banner";
      banner1.innerHTML = banner1El.innerHTML;
      items[5].after(banner1);
    }  
    if (banner2El && items[9]) {
      const banner2 = document.createElement("li");
      banner2.className = "grid__item custom-collection-banner";
      banner2.innerHTML = banner2El.innerHTML;
      items[9].after(banner2);
    }  
    if (banner3El && items[17]) {
      const banner3 = document.createElement("li");
      banner3.className = "grid__item custom-collection-banner";
      banner3.innerHTML = banner3El.innerHTML;
      items[17].after(banner3);
    }

    // ************ product card variant ************ // 
    document.querySelectorAll('.shape-data .slider').forEach(slider => {
      slider.addEventListener('click', e => {
        const cardOption = e.target.closest('.variant-card-option');
        if (!cardOption) return;

        const input = cardOption.querySelector('input[type="radio"]');
        if (!input) return;

        const { imageSrc, secondImageSrc, productId, variantId } = input.dataset;
        if (!imageSrc || !productId || !variantId) return;

        // Mark active
        cardOption.parentElement.querySelectorAll('.variant-card-option').forEach(el => el.classList.remove('active'));
        cardOption.classList.add('active');

        const card = document.querySelector(`.card__media[data-product-id='${productId}']`);
        if (!card) return;

        const updateImage = (selector, src) => {
          const img = card.querySelector(selector);
          if (img && src) {
            img.src = src;
            img.srcset = `
              ${src.replace('.jpg', '_327x327.jpg')} 1x,
              ${src.replace('.jpg', '_1100x1100.jpg')} 2x,
              ${src.replace('.jpg', '_2048x2048.jpg')} 3x
            `.trim();
          }
        };

        updateImage('.desktop-view img.card-main-image', imageSrc);
        updateImage('.desktop-view img.card-second-image', secondImageSrc);
        updateImage('.mobile-slider img.card-main-image', imageSrc);
        updateImage('.mobile-slider img:not(.card-main-image)', secondImageSrc);

        // Update the <a href> inside .media--hover-effect with the variant ID
        const mediaLink = card.querySelector('a.media--hover-effect');
        if (mediaLink) {
          const url = new URL(mediaLink.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          mediaLink.href = url.toString();
        }

        // Also update .card__content link (if needed)
        const cardWrapper = card.closest('.card-wrapper');
        if (cardWrapper) {
          const contentLink = cardWrapper.querySelector('.card__content');
          if (contentLink) {
            const url = new URL(contentLink.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            contentLink.href = url.toString();
          }
        }
      });
    });

    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });

    // ************ select option show in sorting filter ************ //
    const allowedOptions = [
      'Featured',
      'Best selling',
      'Price, low to high',
      'Price, high to low'
    ];
    const sortIds = ['#SortBy', '#SortBy-mobile'];  
    sortIds.forEach(id => {
      const sortBySelect = document.querySelector(id);    
      if (sortBySelect) {
        Array.from(sortBySelect.options).forEach(option => {
          if (!allowedOptions.includes(option.text.trim())) {
            option.remove();
          }
        });
      }
    });

    // ************ desktop active label  ************ //
    const desktopfilterSections = document.querySelectorAll('.desktop-facets__details');
    desktopfilterSections.forEach(section => {
      const checkboxes = section.querySelectorAll('input[type="checkbox"]');
      const activeDesktopLabel = section.querySelector('.active-desktop-label');
      const activeDesktopSummaryLabel = section.querySelector('.active-desktopsummary-label');    
      const updateActiveDesktopLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;    
        const activeText = checkedLabel ? checkedLabel : 'All';    
        if (activeDesktopLabel) {
          activeDesktopLabel.textContent = activeText;
        }    
        if (activeDesktopSummaryLabel) {
          activeDesktopSummaryLabel.textContent = activeText;
        }
      };    
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveDesktopLabel);
      });    
      updateActiveDesktopLabel(); // Initial call on load
    });

    // ************ mobile active label  ************ //
    const filterSections = document.querySelectorAll('.mobile-facets-active-lbl');
    filterSections.forEach(section => {
      const index = section.dataset.index;
      const details = document.querySelector(`.mobile-facets__details[data-index="mobile-${index}"]`);
      const checkboxes = details.querySelectorAll('input[type="checkbox"]');
      const activeMobileLabel = section.querySelector('.active-mobile-label');
      const activeSummaryLabel = details.querySelector('.active-summary-label');    
      const updateActiveLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;    
        const activeText = checkedLabel ? checkedLabel : 'All';    
        activeMobileLabel.textContent = activeText;
        activeSummaryLabel.textContent = activeText;
      }    
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveLabel);
      });    
      updateActiveLabel(); // On page load call
    });

    // ************ select option show in style filter ************ //
    function filterFacetItems(allowedFilters) {
      const facetItems = document.querySelectorAll('.facets__item');
      facetItems.forEach(item => {
        const textLabel = item.querySelector('.custom-facet-checkbox');
        if (textLabel && !allowedFilters.includes(textLabel.textContent.trim())) {
          item.remove();
        }
      });
    }      
    function hideStyleFilter() {
      const desktopStyleFilter = document.querySelector('details.style-filter'); // desktop
      const mobileStyleFilter = document.querySelector('.style-filter.mobile-facets__details'); // mobile
      const mobileStyleContainer = document.querySelector('.mobile-style'); // additional mobile style container      
      if (desktopStyleFilter) {
        desktopStyleFilter.style.display = 'none';
      }      
      if (mobileStyleFilter) {
        mobileStyleFilter.style.display = 'none';
      }      
      if (mobileStyleContainer) {
        mobileStyleContainer.style.display = 'none';
      }
    }      
    const summaryElement = document.querySelector('.custom-facets__summary');
    if (summaryElement) {
      const filterLabelElement = summaryElement.querySelector('.filter-label');
      if (filterLabelElement) {
        const filterLabel = filterLabelElement.textContent.trim();
        const currentPath = window.location.pathname;      
        // Collections where we want to hide the "Style" filter
        const hideStyleCollections = [
          'eternity-rings', 'mens-rings', 'stackable-rings', 'fashion-rings',
          'tennis-necklaces', 'fashion-necklaces',
          'stud-earrings', 'hoop-earrings', 'fashion-earrings',
          'tennis-bracelets', 'bangle-bracelets', 'fashion-bracelets', 'fashion-pendant', 'toi-et-moi', 'exclusive-pick'
        ];      
        // Check if current path contains any of the above collections
        if (hideStyleCollections.some(slug => currentPath.includes(`/collections/${slug}`))) {
          hideStyleFilter();
        }      
        // Existing logic for filter items
        if (currentPath.startsWith('/collections/rings')) {
          const allowedFilters = [
            "Engagement", "Wedding", "Eternity", "Men's Rings", "Stackable", "Fashion", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/engagement-rings')) {
          const allowedFilters = [
            "Halo", "Side Stone", "Solitaire", "Hidden Halo", "Three Stone", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/wedding-rings')) {
          const allowedFilters = [
            "Ring Enhancer", "Wedding & Anniversary"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/necklaces')) {
          const allowedFilters = [
            "Fashion", "Pendant", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/earrings')) {
          const allowedFilters = [
            "Fashion", "Hoop", "Stud"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/bracelets')) {
          const allowedFilters = [
            "Bangle", "Fashion", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/anniversary-gifts')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/gifts-under-1000')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        }
      }
    }
    // ************ at a time only one option select in style filter ************ //
    ['.style-filter', '.shape-filter'].forEach(selector => {
      document.querySelectorAll(selector).forEach(filterWrapper => {
        const checkboxes = filterWrapper.querySelectorAll('input[type="checkbox"]');
    
        checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', function () {
            if (this.checked) {
              checkboxes.forEach(item => {
                if (item !== this) {
                  item.checked = false;
                }
              });
            }
          });
        });
      });
    });
    // ************ end at a time only one option select in style filter ************ //

    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }  
  static renderProductGridContainer(html) {
    // ************ Banner Injection ************ //
    const productGrid = document.querySelector("#product-grid");
    if (!productGrid) return;
    productGrid.querySelectorAll(".custom-collection-banner").forEach(el => el.remove());  
    const banner1El = document.querySelector(".collection-bnr1");
    const banner2El = document.querySelector(".collection-bnr2");
    const banner3El = document.querySelector(".collection-bnr3");
    const items = productGrid.querySelectorAll(".grid__item");
    if (banner1El && items[5]) {
      const banner1 = document.createElement("li");
      banner1.className = "grid__item custom-collection-banner";
      banner1.innerHTML = banner1El.innerHTML;
      items[5].after(banner1);
    }
    if (banner2El && items[9]) {
      const banner2 = document.createElement("li");
      banner2.className = "grid__item custom-collection-banner";
      banner2.innerHTML = banner2El.innerHTML;
      items[9].after(banner2);
    }
    if (banner3El && items[17]) {
      const banner3 = document.createElement("li");
      banner3.className = "grid__item custom-collection-banner";
      banner3.innerHTML = banner3El.innerHTML;
      items[17].after(banner3);
    }

    // ************ product card variant ************ // 
    document.querySelectorAll('.shape-data .slider').forEach(slider => {
      slider.addEventListener('click', e => {
        const cardOption = e.target.closest('.variant-card-option');
        if (!cardOption) return;

        const input = cardOption.querySelector('input[type="radio"]');
        if (!input) return;

        const { imageSrc, secondImageSrc, productId, variantId } = input.dataset;
        if (!imageSrc || !productId || !variantId) return;

        // Mark active
        cardOption.parentElement.querySelectorAll('.variant-card-option').forEach(el => el.classList.remove('active'));
        cardOption.classList.add('active');

        const card = document.querySelector(`.card__media[data-product-id='${productId}']`);
        if (!card) return;

        const updateImage = (selector, src) => {
          const img = card.querySelector(selector);
          if (img && src) {
            img.src = src;
            img.srcset = `
              ${src.replace('.jpg', '_327x327.jpg')} 1x,
              ${src.replace('.jpg', '_1100x1100.jpg')} 2x,
              ${src.replace('.jpg', '_2048x2048.jpg')} 3x
            `.trim();
          }
        };

        updateImage('.desktop-view img.card-main-image', imageSrc);
        updateImage('.desktop-view img.card-second-image', secondImageSrc);
        updateImage('.mobile-slider img.card-main-image', imageSrc);
        updateImage('.mobile-slider img:not(.card-main-image)', secondImageSrc);

        // Update the <a href> inside .media--hover-effect with the variant ID
        const mediaLink = card.querySelector('a.media--hover-effect');
        if (mediaLink) {
          const url = new URL(mediaLink.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          mediaLink.href = url.toString();
        }

        // Also update .card__content link (if needed)
        const cardWrapper = card.closest('.card-wrapper');
        if (cardWrapper) {
          const contentLink = cardWrapper.querySelector('.card__content');
          if (contentLink) {
            const url = new URL(contentLink.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            contentLink.href = url.toString();
          }
        }
      });
    });

    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });

    // ************ select option show in sorting filter ************ //
    const allowedOptions = [
      'Featured',
      'Best selling',
      'Price, low to high',
      'Price, high to low'
    ];
    const sortIds = ['#SortBy', '#SortBy-mobile'];
    sortIds.forEach(id => {
      const sortBySelect = document.querySelector(id);
      if (sortBySelect) {
        Array.from(sortBySelect.options).forEach(option => {
          if (!allowedOptions.includes(option.text.trim())) {
            option.remove();
          }
        });
      }
    });

     // ************ desktop active label  ************ //
    const desktopfilterSections = document.querySelectorAll('.desktop-facets__details');
    desktopfilterSections.forEach(section => {
      const checkboxes = section.querySelectorAll('input[type="checkbox"]');
      const activeDesktopLabel = section.querySelector('.active-desktop-label');
      const activeDesktopSummaryLabel = section.querySelector('.active-desktopsummary-label');
  
      const updateActiveDesktopLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;
  
        const activeText = checkedLabel ? checkedLabel : 'All';
  
        if (activeDesktopLabel) {
          activeDesktopLabel.textContent = activeText;
        }
  
        if (activeDesktopSummaryLabel) {
          activeDesktopSummaryLabel.textContent = activeText;
        }
      };
  
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveDesktopLabel);
      });
  
      updateActiveDesktopLabel(); // Initial call on load
    });

    // ************ mobile active label  ************ //
    const filterSections = document.querySelectorAll('.mobile-facets-active-lbl');
    filterSections.forEach(section => {
      const index = section.dataset.index;
      const details = document.querySelector(`.mobile-facets__details[data-index="mobile-${index}"]`);
      const checkboxes = details.querySelectorAll('input[type="checkbox"]');
      const activeMobileLabel = section.querySelector('.active-mobile-label');
      const activeSummaryLabel = details.querySelector('.active-summary-label');
  
      const updateActiveLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;
  
        const activeText = checkedLabel ? checkedLabel : 'All';
  
        activeMobileLabel.textContent = activeText;
        activeSummaryLabel.textContent = activeText;
      };
  
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveLabel);
      });
  
      updateActiveLabel(); // On page load call
    });
    // ************ end mobile active label  ************ //

    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }
  static renderProductCount(html) {
    // ************ Banner Injection ************ //
    const productGrid = document.querySelector("#product-grid");
    if (!productGrid) return;
    productGrid.querySelectorAll(".custom-collection-banner").forEach(el => el.remove());
    const banner1El = document.querySelector(".collection-bnr1");
    const banner2El = document.querySelector(".collection-bnr2");
    const banner3El = document.querySelector(".collection-bnr3");
    const items = productGrid.querySelectorAll(".grid__item");
    if (banner1El && items[5]) {
      const banner1 = document.createElement("li");
      banner1.className = "grid__item custom-collection-banner";
      banner1.innerHTML = banner1El.innerHTML;
      items[5].after(banner1);
    }
    if (banner2El && items[9]) {
      const banner2 = document.createElement("li");
      banner2.className = "grid__item custom-collection-banner";
      banner2.innerHTML = banner2El.innerHTML;
      items[9].after(banner2);
    }
    if (banner3El && items[17]) {
      const banner3 = document.createElement("li");
      banner3.className = "grid__item custom-collection-banner";
      banner3.innerHTML = banner3El.innerHTML;
      items[17].after(banner3);
    }

    // ************ product card variant ************ // 
    document.querySelectorAll('.shape-data .slider').forEach(slider => {
      slider.addEventListener('click', e => {
        const cardOption = e.target.closest('.variant-card-option');
        if (!cardOption) return;

        const input = cardOption.querySelector('input[type="radio"]');
        if (!input) return;

        const { imageSrc, secondImageSrc, productId, variantId } = input.dataset;
        if (!imageSrc || !productId || !variantId) return;

        // Mark active
        cardOption.parentElement.querySelectorAll('.variant-card-option').forEach(el => el.classList.remove('active'));
        cardOption.classList.add('active');

        const card = document.querySelector(`.card__media[data-product-id='${productId}']`);
        if (!card) return;

        const updateImage = (selector, src) => {
          const img = card.querySelector(selector);
          if (img && src) {
            img.src = src;
            img.srcset = `
              ${src.replace('.jpg', '_327x327.jpg')} 1x,
              ${src.replace('.jpg', '_1100x1100.jpg')} 2x,
              ${src.replace('.jpg', '_2048x2048.jpg')} 3x
            `.trim();
          }
        };

        updateImage('.desktop-view img.card-main-image', imageSrc);
        updateImage('.desktop-view img.card-second-image', secondImageSrc);
        updateImage('.mobile-slider img.card-main-image', imageSrc);
        updateImage('.mobile-slider img:not(.card-main-image)', secondImageSrc);

        // Update the <a href> inside .media--hover-effect with the variant ID
        const mediaLink = card.querySelector('a.media--hover-effect');
        if (mediaLink) {
          const url = new URL(mediaLink.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          mediaLink.href = url.toString();
        }

        // Also update .card__content link (if needed)
        const cardWrapper = card.closest('.card-wrapper');
        if (cardWrapper) {
          const contentLink = cardWrapper.querySelector('.card__content');
          if (contentLink) {
            const url = new URL(contentLink.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            contentLink.href = url.toString();
          }
        }
      });
    });

    // ************ product image mobile slider ************ // 
    $(".mobile-slider .slider").slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000
    });

    // ************ product shape icon slider ************ // 
    const isListView = document.querySelector('.list-view.active') !== null;
    $(".product-form__input .slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      prevArrow: `<div class="slide-arrow prev-arrow"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.11523 5.9994L7.24023 1.87445L6.0619 0.696047L0.758564 5.9994L6.0619 11.3027L7.24023 10.1244L3.11523 5.9994Z" fill="#09121F"/></svg></div>`,
      nextArrow: `<div class="slide-arrow next-arrow"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.88477 5.9994L0.759766 1.87445L1.9381 0.696047L7.24144 5.9994L1.9381 11.3027L0.759766 10.1244L4.88477 5.9994Z" fill="#09121F"/></svg></div>`,
        responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        destroySlickSlider();
        initializeMobileSlickSlider();
        initializeCardSlickSlider();
      }, 300); // debounce
    });
    document.querySelectorAll('.grid-view, .list-view').forEach(btn => {
      btn.addEventListener('click', function () {
        setTimeout(() => { // wait for .active class to update
          destroySlickSlider();
          initializeMobileSlickSlider();
          initializeCardSlickSlider();
        }, 0);
      });
    });

    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });

    // ************ select option show in sorting filter ************ //
    const allowedOptions = [
      'Featured',
      'Best selling',
      'Price, low to high',
      'Price, high to low'
    ];
    const sortIds = ['#SortBy', '#SortBy-mobile'];  
    sortIds.forEach(id => {
      const sortBySelect = document.querySelector(id);
      if (sortBySelect) {
        Array.from(sortBySelect.options).forEach(option => {
          if (!allowedOptions.includes(option.text.trim())) {
            option.remove();
          }
        });
      }
    });

    // ************ desktop active label  ************ //
    const desktopfilterSections = document.querySelectorAll('.desktop-facets__details');
    desktopfilterSections.forEach(section => {
      const checkboxes = section.querySelectorAll('input[type="checkbox"]');
      const activeDesktopLabel = section.querySelector('.active-desktop-label');
      const activeDesktopSummaryLabel = section.querySelector('.active-desktopsummary-label');
  
      const updateActiveDesktopLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;
  
        const activeText = checkedLabel ? checkedLabel : 'All';
  
        if (activeDesktopLabel) {
          activeDesktopLabel.textContent = activeText;
        }
  
        if (activeDesktopSummaryLabel) {
          activeDesktopSummaryLabel.textContent = activeText;
        }
      };
  
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveDesktopLabel);
      });
  
      updateActiveDesktopLabel(); // Initial call on load
    });

    // ************ mobile active label  ************ //
    const filterSections = document.querySelectorAll('.mobile-facets-active-lbl');
    filterSections.forEach(section => {
      const index = section.dataset.index;
      const details = document.querySelector(`.mobile-facets__details[data-index="mobile-${index}"]`);
      const checkboxes = details.querySelectorAll('input[type="checkbox"]');
      const activeMobileLabel = section.querySelector('.active-mobile-label');
      const activeSummaryLabel = details.querySelector('.active-summary-label');
  
      const updateActiveLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;
  
        const activeText = checkedLabel ? checkedLabel : 'All';
  
        activeMobileLabel.textContent = activeText;
        activeSummaryLabel.textContent = activeText;
      };
  
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveLabel);
      });    
      updateActiveLabel(); // On page load call
    });

    // ************ select option show in style filter ************ //
    function filterFacetItems(allowedFilters) {
      const facetItems = document.querySelectorAll('.facets__item');
      facetItems.forEach(item => {
        const textLabel = item.querySelector('.custom-facet-checkbox');
        if (textLabel && !allowedFilters.includes(textLabel.textContent.trim())) {
          item.remove();
        }
      });
    }
    function hideStyleFilter() {
      const desktopStyleFilter = document.querySelector('details.style-filter'); // desktop
      const mobileStyleFilter = document.querySelector('.style-filter.mobile-facets__details'); // mobile
      const mobileStyleContainer = document.querySelector('.mobile-style'); // additional mobile style container      
      if (desktopStyleFilter) {
        desktopStyleFilter.style.display = 'none';
      }      
      if (mobileStyleFilter) {
        mobileStyleFilter.style.display = 'none';
      }      
      if (mobileStyleContainer) {
        mobileStyleContainer.style.display = 'none';
      }
    }
    const summaryElement = document.querySelector('.custom-facets__summary');
    if (summaryElement) {
      const filterLabelElement = summaryElement.querySelector('.filter-label');
      if (filterLabelElement) {
        const filterLabel = filterLabelElement.textContent.trim();
        const currentPath = window.location.pathname;
    
        // Collections where we want to hide the "Style" filter
        const hideStyleCollections = [
          'eternity-rings', 'mens-rings', 'stackable-rings', 'fashion-rings',
          'tennis-necklaces', 'fashion-necklaces',
          'stud-earrings', 'hoop-earrings', 'fashion-earrings',
          'tennis-bracelets', 'bangle-bracelets', 'fashion-bracelets', 'fashion-pendant', 'toi-et-moi', 'exclusive-pick'
        ];
    
        // Check if current path contains any of the above collections
        if (hideStyleCollections.some(slug => currentPath.includes(`/collections/${slug}`))) {
          hideStyleFilter();
        }
    
        // Existing logic for filter items
        if (currentPath.startsWith('/collections/rings')) {
          const allowedFilters = [
            "Engagement", "Wedding", "Eternity", "Men's Rings", "Stackable", "Fashion", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/engagement-rings')) {
          const allowedFilters = [
            "Halo", "Side Stone", "Solitaire", "Hidden Halo", "Three Stone", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/wedding-rings')) {
          const allowedFilters = [
            "Ring Enhancer", "Wedding & Anniversary"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/necklaces')) {
          const allowedFilters = [
            "Fashion", "Pendant", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/earrings')) {
          const allowedFilters = [
            "Fashion", "Hoop", "Stud"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/bracelets')) {
          const allowedFilters = [
            "Bangle", "Fashion", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/anniversary-gifts')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/gifts-under-1000')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        }
      }
    }
    // ************ at a time only one option select in style filter ************ //
    ['.style-filter', '.shape-filter'].forEach(selector => {
      document.querySelectorAll(selector).forEach(filterWrapper => {
        const checkboxes = filterWrapper.querySelectorAll('input[type="checkbox"]');
    
        checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', function () {
            if (this.checked) {
              checkboxes.forEach(item => {
                if (item !== this) {
                  item.checked = false;
                }
              });
            }
          });
        });
      });
    });
    // ************ end at a time only one option select in style filter ************ //

    // const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    // const container = document.getElementById('ProductCount');
    // const containerDesktop = document.getElementById('ProductCountDesktop');
    // container.innerHTML = count;
    // container.classList.remove('loading');
    // if (containerDesktop) {
    //   containerDesktop.innerHTML = count;
    //   containerDesktop.classList.remove('loading');
    // }
    // const loadingSpinners = document.querySelectorAll(
    //   '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    // );
    // loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }  
  static renderFilters(html, event) {
    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });

    // ************ select option show in sorting filter ************ //
    const allowedOptions = [
      'Featured',
      'Best selling',
      'Price, low to high',
      'Price, high to low'
    ];  
    const sortIds = ['#SortBy', '#SortBy-mobile'];  
    sortIds.forEach(id => {
      const sortBySelect = document.querySelector(id);  
      if (sortBySelect) {
        Array.from(sortBySelect.options).forEach(option => {
          if (!allowedOptions.includes(option.text.trim())) {
            option.remove();
          }
        });
      }
    });
    // ************ end select option show in sorting filter ************ //
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });
    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender) { 
      const closestJSFilterID = event.target.closest('.js-filter').id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        const isTextInput = event.target.getAttribute('type') === 'text';
        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }
  static renderActiveFacets(html) {    
    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });
    // ************ end mobile filter option slider ************ //
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }
  static renderAdditionalElements(html) {
    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
          slidesPerView: 7,
        },
        750: {
          slidesPerView: 5,
        },
        380: {
          slidesPerView: 4,
        },
        320: {
          slidesPerView: 2,
        }
      }
    });
    // ************ end mobile filter option slider ************ //
  
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents?.();
  }
  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }
    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');
    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }
    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');
    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
    // ************ Banner Injection ************ //
    const productGrid = document.querySelector("#product-grid");
    if (!productGrid) return;
    productGrid.querySelectorAll(".custom-collection-banner").forEach(el => el.remove());  
    const banner1El = document.querySelector(".collection-bnr1");
    const banner2El = document.querySelector(".collection-bnr2");
    const banner3El = document.querySelector(".collection-bnr3");  
    const items = productGrid.querySelectorAll(".grid__item");  
    if (banner1El && items[5]) {
      const banner1 = document.createElement("li");
      banner1.className = "grid__item custom-collection-banner";
      banner1.innerHTML = banner1El.innerHTML;
      items[5].after(banner1);
    }  
    if (banner2El && items[9]) {
      const banner2 = document.createElement("li");
      banner2.className = "grid__item custom-collection-banner";
      banner2.innerHTML = banner2El.innerHTML;
      items[9].after(banner2);
    }  
    if (banner3El && items[17]) {
      const banner3 = document.createElement("li");
      banner3.className = "grid__item custom-collection-banner";
      banner3.innerHTML = banner3El.innerHTML;
      items[17].after(banner3);
    }

    // ************ select option show in style filter ************ //
     function filterFacetItems(allowedFilters) {
      const facetItems = document.querySelectorAll('.facets__item');
      facetItems.forEach(item => {
        const textLabel = item.querySelector('.custom-facet-checkbox');
        if (textLabel && !allowedFilters.includes(textLabel.textContent.trim())) {
          item.remove();
        }
      });
    }

    // ************ product card variant ************ // 
    document.querySelectorAll('.shape-data .slider').forEach(slider => {
      slider.addEventListener('click', e => {
        const cardOption = e.target.closest('.variant-card-option');
        if (!cardOption) return;

        const input = cardOption.querySelector('input[type="radio"]');
        if (!input) return;

        const { imageSrc, secondImageSrc, productId, variantId } = input.dataset;
        if (!imageSrc || !productId || !variantId) return;

        // Mark active
        cardOption.parentElement.querySelectorAll('.variant-card-option').forEach(el => el.classList.remove('active'));
        cardOption.classList.add('active');

        const card = document.querySelector(`.card__media[data-product-id='${productId}']`);
        if (!card) return;

        const updateImage = (selector, src) => {
          const img = card.querySelector(selector);
          if (img && src) {
            img.src = src;
            img.srcset = `
              ${src.replace('.jpg', '_327x327.jpg')} 1x,
              ${src.replace('.jpg', '_1100x1100.jpg')} 2x,
              ${src.replace('.jpg', '_2048x2048.jpg')} 3x
            `.trim();
          }
        };

        updateImage('.desktop-view img.card-main-image', imageSrc);
        updateImage('.desktop-view img.card-second-image', secondImageSrc);
        updateImage('.mobile-slider img.card-main-image', imageSrc);
        updateImage('.mobile-slider img:not(.card-main-image)', secondImageSrc);

        // Update the <a href> inside .media--hover-effect with the variant ID
        const mediaLink = card.querySelector('a.media--hover-effect');
        if (mediaLink) {
          const url = new URL(mediaLink.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          mediaLink.href = url.toString();
        }

        // Also update .card__content link (if needed)
        const cardWrapper = card.closest('.card-wrapper');
        if (cardWrapper) {
          const contentLink = cardWrapper.querySelector('.card__content');
          if (contentLink) {
            const url = new URL(contentLink.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            contentLink.href = url.toString();
          }
        }
      });
    });

    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });

    // ************ select option show in sorting filter ************ //
    const allowedOptions = [
      'Featured',
      'Best selling',
      'Price, low to high',
      'Price, high to low'
    ];
    const sortIds = ['#SortBy', '#SortBy-mobile'];  
    sortIds.forEach(id => {
      const sortBySelect = document.querySelector(id);
  
      if (sortBySelect) {
        Array.from(sortBySelect.options).forEach(option => {
          if (!allowedOptions.includes(option.text.trim())) {
            option.remove();
          }
        });
      }
    });

    // ************ desktop active label  ************ //
    const desktopfilterSections = document.querySelectorAll('.desktop-facets__details');
    desktopfilterSections.forEach(section => {
      const checkboxes = section.querySelectorAll('input[type="checkbox"]');
      const activeDesktopLabel = section.querySelector('.active-desktop-label');
      const activeDesktopSummaryLabel = section.querySelector('.active-desktopsummary-label');    
      const updateActiveDesktopLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;    
        const activeText = checkedLabel ? checkedLabel : 'All';    
        if (activeDesktopLabel) {
          activeDesktopLabel.textContent = activeText;
        }    
        if (activeDesktopSummaryLabel) {
          activeDesktopSummaryLabel.textContent = activeText;
        }
      };    
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveDesktopLabel);
      });    
      updateActiveDesktopLabel(); // Initial call on load
    });

    // ************ mobile active label  ************ //
    const filterSections = document.querySelectorAll('.mobile-facets-active-lbl');
    filterSections.forEach(section => {
      const index = section.dataset.index;
      const details = document.querySelector(`.mobile-facets__details[data-index="mobile-${index}"]`);
      const checkboxes = details.querySelectorAll('input[type="checkbox"]');
      const activeMobileLabel = section.querySelector('.active-mobile-label');
      const activeSummaryLabel = details.querySelector('.active-summary-label');    
      const updateActiveLabel = () => {
        const checkedLabel = Array.from(checkboxes).find(checkbox => checkbox.checked)?.closest('.facet-checkbox')?.querySelector('.facet-checkbox__text-label')?.textContent;    
        const activeText = checkedLabel ? checkedLabel : 'All';    
        activeMobileLabel.textContent = activeText;
        activeSummaryLabel.textContent = activeText;
      };  
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateActiveLabel);
      });  
      updateActiveLabel(); // On page load call
    });

    // ************ select option show in style filter ************ //
    function filterFacetItems(allowedFilters) {
      const facetItems = document.querySelectorAll('.facets__item');
      facetItems.forEach(item => {
        const textLabel = item.querySelector('.custom-facet-checkbox');
        if (textLabel && !allowedFilters.includes(textLabel.textContent.trim())) {
          item.remove();
        }
      });
    }      
    function hideStyleFilter() {
      const desktopStyleFilter = document.querySelector('details.style-filter'); 
      const mobileStyleFilter = document.querySelector('.style-filter.mobile-facets__details'); 
      const mobileStyleContainer = document.querySelector('.mobile-style');  
      if (desktopStyleFilter) {
        desktopStyleFilter.style.display = 'none';
      }      
      if (mobileStyleFilter) {
        mobileStyleFilter.style.display = 'none';
      }
    
      if (mobileStyleContainer) {
        mobileStyleContainer.style.display = 'none';
      }
    }      
    const summaryElement = document.querySelector('.custom-facets__summary');
    if (summaryElement) {
      const filterLabelElement = summaryElement.querySelector('.filter-label');
      if (filterLabelElement) {
        const filterLabel = filterLabelElement.textContent.trim();
        const currentPath = window.location.pathname;      
        // Collections where we want to hide the "Style" filter
        const hideStyleCollections = [
          'eternity-rings', 'mens-rings', 'stackable-rings', 'fashion-rings',
          'tennis-necklaces', 'fashion-necklaces',
          'stud-earrings', 'hoop-earrings', 'fashion-earrings',
          'tennis-bracelets', 'bangle-bracelets', 'fashion-bracelets', 'fashion-pendant', 'toi-et-moi', 'exclusive-pick'
        ];      
        // Check if current path contains any of the above collections
        if (hideStyleCollections.some(slug => currentPath.includes(`/collections/${slug}`))) {
          hideStyleFilter();
        }      
        // Existing logic for filter items
        if (currentPath.startsWith('/collections/rings')) {
          const allowedFilters = [
            "Engagement", "Wedding", "Eternity", "Men's Rings", "Stackable", "Fashion", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/engagement-rings')) {
          const allowedFilters = [
            "Halo", "Side Stone", "Solitaire", "Hidden Halo", "Three Stone", "Toi Et Moi"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/wedding-rings')) {
          const allowedFilters = [
            "Ring Enhancer", "Wedding & Anniversary"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/necklaces')) {
          const allowedFilters = [
            "Fashion", "Pendant", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/earrings')) {
          const allowedFilters = [
            "Fashion", "Hoop", "Stud"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/bracelets')) {
          const allowedFilters = [
            "Bangle", "Fashion", "Tennis"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/anniversary-gifts')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        } else if (currentPath.startsWith('/collections/gifts-under-1000')) {
          const allowedFilters = [
            "Engagement rings", "Wedding rings", "Rings", "Bracelets", "Necklaces", "Earrings"
          ];
          filterFacetItems(allowedFilters);
        }
      }
    }

    // ************ at a time only one option select in style filter ************ //
    ['.style-filter', '.shape-filter'].forEach(selector => {
      document.querySelectorAll(selector).forEach(filterWrapper => {
        const checkboxes = filterWrapper.querySelectorAll('input[type="checkbox"]');      
        checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', function () {
            if (this.checked) {
              checkboxes.forEach(item => {
                if (item !== this) {
                  item.checked = false;
                }
              });
            }
          });
        });
      });
    });
    // ************ end at a time only one option select in style filter ************ //
  }
  static renderMobileCounts(source, target) {
    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });
    // ************ end mobile filter option slider ************ //

    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');
    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }
  static updateURLHash(searchParams) {
    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });
    // ************ end mobile filter option slider ************ //
    
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }
  onSubmitHandler(event) {
    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });
    // ************ end mobile filter option slider ************ //

    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } 
    else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile'; 
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    // ************ mobile filter option slider ************ //
    var swiper = new Swiper(".mobile-facets__submenu", {
      slidesPerView: 7,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: ".product-arrow.swiper-button-next",
        prevEl: ".product-arrow.swiper-button-prev",
      },
      breakpoints: {
        850: {
            slidesPerView: 7,
        },
        750: {
            slidesPerView: 5,
        },
        380: {
            slidesPerView: 4,
        },
        320: {
            slidesPerView: 2,
        }
      }
    });
    // ************ end mobile filter option slider ************ //

    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }
  onKeyDown(event) {
    if (event.metaKey) return;
    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }
  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}
customElements.define('facet-remove', FacetRemove);